<div class="check-before">
  <div class="modal-header">
    <span class="dialog-title">
      <mat-icon>settings</mat-icon>
      <span style="margin-left: 5px">{{'check_modal_invite' | translate}}</span>
    </span>

    <button class="close-button"
            (click)="dialogRef.close()"
            aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>


  <div class="cbi-content">
    <div class="choose-btn" (click)="dialogRef.close(1)">{{'child' | translate}}</div>
    <div>{{'or' | translate}}</div>
    <div class="choose-btn" (click)="dialogRef.close(2)">{{'adult' | translate}}</div>
  </div>
</div>
